import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Storage } from '@ionic/storage-angular';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private storage: Storage
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    // If trying to access sign-in page, check if already logged in
    if (state.url === '/sign-in' || state.url === '') {
      const chatUser = await this.storage.get('chatuser');
      
      if (chatUser && chatUser.id) {
        // User already logged in, prevent access to sign-in
        if (chatUser.role === 'user') {
          this.router.navigate(['/chatting'], { replaceUrl: true });
        } else if (chatUser.role === 'admin') {
          this.router.navigate(['/chat-list'], { replaceUrl: true });
        }
        return false;
      }
    }
    
    return true;
  }
}
